module.exports = __webpack_public_path__ + "2dfb43480b1509dbdbf288a5385aac82.pdf";